import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'underscoreToHyphen',
    standalone: true,
})
export class UnderscoreToHyphenPipe implements PipeTransform {
    transform(value: string | null | undefined): string | null | undefined {
        if (value) {
            return value.replace(/_/g, '-');
        }
        return value;
    }
}
